import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["title", "subtitle", "badge", "size", "onClick"];
import React from 'react';
import { Avatar, AvatarSize } from '../Avatar';
import { Badge } from '../Badge';
import { Box } from '../Box';
import { Spacer } from '../Spacer';
import { Typography } from '../Typography';
import { getBadgeSize, getSpaceVariant, getSubTitleVariant, getTitleVariant } from './utils';

var Persona = function Persona(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      badge = _ref.badge,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? AvatarSize.MEDIUM : _ref$size,
      onClick = _ref.onClick,
      avatarProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var titleVariant = getTitleVariant(size);
  var subtitleVariant = getSubTitleVariant(size);
  var spaceVariant = getSpaceVariant(size);
  var badgeSize = getBadgeSize(size);
  var hasAvatar = !!avatarProps.src || !!avatarProps.children || !!avatarProps.icon;
  var avatar = hasAvatar ? /*#__PURE__*/React.createElement(Avatar, _extends({}, avatarProps, {
    size: size
  })) : null;
  return /*#__PURE__*/React.createElement(Spacer, {
    space: spaceVariant,
    alignItems: "center",
    onClick: onClick,
    cursor: onClick && 'pointer'
  }, badge ? /*#__PURE__*/React.createElement(Badge, _extends({
    size: badgeSize
  }, badge), avatar) : avatar, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    variant: titleVariant,
    textAlign: "left"
  }, title), subtitle && /*#__PURE__*/React.createElement(Typography, {
    variant: subtitleVariant,
    color: "text.dark",
    textAlign: "left"
  }, subtitle)));
};

export default Persona;